export function catchUnhandledDashboardError(message: Event | string, file?: string, line?: number, col?: number, error?: Error): void {
    console.warn("Unhandled error:", message, file, line, col, error);
}
